import LogoutButton from './LogoutButton.jsx';

export default LogoutButton;
